<template>
  <div>
    <!-- 列表模式 -->
    <template v-if="!printMode">
    <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div style="padding: 10px; background: #f0f0f0; margin-bottom: 10px;">
          <strong>销售报表模块</strong> - 版本测试
        </div>
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <store-tenant-select domain="sale" @change="handleStoreTenantChange"></store-tenant-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="操作员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    placeholder="请选择操作员"
                    allow-clear
                    style="width: 100%"
                    v-model="queryParam.creator">
                    <a-select-option v-for="(item, index) in userList" :key="index" :value="item.id">
                      {{ item.userName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="客户" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    placeholder="请选择客户"
                    allow-clear
                    show-search
                    style="width: 100%"
                    v-model="queryParam.customerId">
                    <a-select-option v-for="(item, index) in cusList" :key="index" :value="item.id">
                      {{ item.supplier }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    placeholder="请选择仓库"
                    allow-clear
                    style="width: 100%"
                    v-model="queryParam.depotId">
                    <a-select-option v-for="(item, index) in depotList" :key="index" :value="item.id">
                      {{ item.depotName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tree-select
                    style="width: 100%"
                    :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                    allow-clear
                    :treeData="categoryTree"
                    v-model="queryParam.categoryId"
                    placeholder="请选择类别">
                  </a-tree-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-range-picker
                    style="width: 100%"
                    v-model="queryParam.dateRange"
                    format="YYYY-MM-DD"
                    :placeholder="['开始日期', '结束日期']"
                    @change="onDateChange"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    placeholder="请选择排序方式"
                    style="width: 100%"
                    v-model="queryParam.sortType">
                    <a-select-option v-for="(item, index) in sortOptions" :key="index" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="orgaTree.length">
                <a-form-item label="机构" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-tree-select style="width:100%" allow-clear :treeData="orgaTree"
                                 v-model="queryParam.organizationId" placeholder="请选择机构">
                  </a-tree-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <a-button style="margin-left: 8px" icon="printer" v-if="btnEnableList.indexOf('5')>-1"
                    @click="handlePrint">打印</a-button>
                  <a-button style="margin-left: 8px" @click="exportExcel" icon="download" v-if="btnEnableList.indexOf('3')>-1">导出</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <section ref="print" id="reportPrint">
          <a-table
            bordered
            ref="table"
            size="middle"
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
          </a-table>
          <a-row :gutter="24" style="margin-top: 8px; textAlign: left">
            <a-col :md="24" :sm="24">
              <a-pagination
                @change="paginationChange"
                @showSizeChange="paginationShowSizeChange"
                size="small"
                show-size-changer
                show-quick-jumper
                :current="ipagination.current"
                :page-size="ipagination.pageSize"
                :page-size-options="ipagination.pageSizeOptions"
                :total="ipagination.total"
              />
            </a-col>
          </a-row>
        </section>
      </a-card>
    </a-col>
    </a-row>
    </template>

    <!-- 打印模式（内嵌） -->
    <template v-if="printMode">
      <div class="print-header" style="display:flex; justify-content:space-between; align-items:center; padding:8px 16px; background:#fff; border-bottom:1px solid #e8e8e8; margin-bottom:12px;">
        <span style="font-size:16px; font-weight:500;">{{ printTitle }}</span>
        <a-button icon="close" @click="printMode = false">关闭</a-button>
      </div>
      <ReportPrint
        :visible="true"
        :tableData="dataSource"
        :queryParam="queryParam"
        billType="SALES_RANKING"
        billTypeName="销售排行"
        :buildData="buildPrintData"
        :embedded="true"
        @designer-change="onDesignerChange"
        @back="printMode = false"
      />
    </template>
  </div>
</template>
<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getUserList, queryMaterialCategoryTreeList, findBySelectCus, getAllOrganizationTreeByUser } from '@/api/api'
import { getAction } from '@/api/manage'
import moment from 'moment'
import ReportPrint from '@/views/plugin/print-template/ReportPrint.vue'
import StoreTenantSelect from '@/components/StoreTenantSelect'
import { defColumns, sortOptions, exportHead, exportFields, buildPrintData } from './salesRankingConfig'

  export default {
    name: "SalesRankingList",
    mixins: [JeecgListMixin],
    components: {
      ReportPrint,
      StoreTenantSelect
    },
    data() {
      return {
        labelCol: { span: 6 },
        wrapperCol: { span: 17, offset: 1 },
        queryParam: {
          creator: undefined,
          customerId: undefined,
          depotId: undefined,
          categoryId: undefined,
          organizationId: undefined,
          sortType: 'quantity_desc',
          beginTime: moment().subtract(3, 'months').format('YYYY-MM-DD'),
          endTime: moment().format('YYYY-MM-DD'),
          dateRange: [moment().subtract(3, 'months'), moment()],
        },
        ipagination: {
          current: 1,
          pageSize: 11,
          pageSizeOptions: ['10', '20', '30', '50', '100'],
          total: 0
        },
        sortOptions: [
          { label: '按销售数量降序', value: 'quantity_desc' },
          { label: '按销售数量升序', value: 'quantity_asc' },
          { label: '按销售金额降序', value: 'amount_desc' },
          { label: '按销售金额升序', value: 'amount_asc' }
        ],
        userList: [],
        cusList: [],
        depotList: [],
        categoryTree: [],
        orgaTree: [],
        columns: [],
        defColumns: defColumns,
        url: {
          list: '/api/plugin/sale-sort/saleSort/getList'
        },
        urlPath: '/report/sales_ranking',
        printMode: false,
        printTitle: '销售排行-打印预览'
      }
    },
    created() {
      this.columns = this.defColumns
      this.loadUserData()
      this.initCustomer()
      this.loadDepotData()
      this.loadCategoryTreeData()
      this.initOrga()
    },
    methods: {
      moment,
      buildPrintData,
      handleStoreTenantChange() {
        this.searchQuery()
      },
      handlePrint() {
        if (!this.dataSource || this.dataSource.length === 0) {
          this.$message.warning('暂无数据可打印')
          return
        }
        this.printTitle = '销售排行-打印预览'
        this.printMode = true
      },
      onDesignerChange(visible) {
        this.printTitle = visible ? '销售排行-报表设计' : '销售排行-打印预览'
      },
      getQueryParams() {
        const dateRange = this.queryParam.dateRange || []
        return {
          creator: this.queryParam.creator || undefined,
          customerId: this.queryParam.customerId || undefined,
          depotId: this.queryParam.depotId || undefined,
          categoryId: this.queryParam.categoryId || undefined,
          organizationId: this.queryParam.organizationId || undefined,
          sortType: this.queryParam.sortType || undefined,
          beginTime: dateRange[0] ? dateRange[0].format('YYYY-MM-DD') : undefined,
          endTime: dateRange[1] ? dateRange[1].format('YYYY-MM-DD') : undefined,
          currentPage: this.ipagination.current,
          pageSize: this.ipagination.pageSize - 1
        }
      },
      onDateChange(value, dateString) {
        if (dateString && dateString.length === 2) {
          this.queryParam.beginTime = dateString[0]
          this.queryParam.endTime = dateString[1]
        }
      },
      loadData(arg) {
        if (arg === 1) {
          this.ipagination.current = 1
        }
        let params = this.getQueryParams()
        this.loading = true
        getAction(this.url.list, params).then((res) => {
          if (res.code === 200) {
            this.dataSource = res.data.rows || []
            this.ipagination.total = res.data.total || 0
            this.tableAddTotalRow(this.columns, this.dataSource)
          } else if (res.code === 510) {
            this.$message.warning(res.data)
          } else {
            this.$message.warning(res.data.message)
          }
          this.loading = false
        })
      },
      tableAddTotalRow(columns, dataSource) {
        if (dataSource.length > 0) {
          let numKey = 'rowIndex'
          let totalRow = { [numKey]: '合计' }
          let parseCols = 'numSum,priceSum,'
          columns.forEach(column => {
            let { key, dataIndex } = column
            if (![key, dataIndex].includes(numKey)) {
              let total = 0
              let hasSum = false
              dataSource.forEach(data => {
                if (parseCols.indexOf(dataIndex + ',') > -1) {
                  hasSum = true
                  if (data[dataIndex]) {
                    total += Number.parseFloat(data[dataIndex])
                  }
                }
              })
              if (hasSum) {
                totalRow[dataIndex] = total.toFixed(2)
              } else {
                totalRow[dataIndex] = ''
              }
            }
          })
          dataSource.push(totalRow)
          let size = Math.ceil(this.ipagination.total / (this.ipagination.pageSize - 1))
          this.ipagination.total = this.ipagination.total + size
        }
      },
      getPreviewData() {
        const userInfo = this.$store && this.$store.getters && (this.$store.getters.userInfo || (this.$store.state.user && this.$store.state.user.info))
        return {
          reportTitle: '销售排行',
          reportDate: new Date().toLocaleDateString(),
          table: (this.dataSource || []).map((item, idx) => ({
            ...item,
            rowIndex: idx + 1
          })),
          companyName: (userInfo && userInfo.companyName) || '',
          companyContacts: '',
          companyAddress: '',
          companyTel: '',
          companyFax: ''
        }
      },
      loadUserData() {
        getUserList({}).then((res) => {
          if (res) {
            this.userList = res
          }
        })
      },
      initCustomer() {
        findBySelectCus({ limit: 1 }).then((res) => {
          if (res) {
            this.cusList = res
          }
        })
      },
      loadDepotData() {
        getAction('/depot/findDepotByCurrentUser').then((res) => {
          if (res.code === 200) {
            this.depotList = res.data || []
          } else {
            this.$message.info(res.data)
          }
        })
      },
      loadCategoryTreeData() {
        queryMaterialCategoryTreeList({ id: '' }).then((res) => {
          if (res) {
            this.categoryTree = []
            for (let i = 0; i < res.length; i++) {
              this.categoryTree.push(res[i])
            }
          }
        })
      },
      initOrga() {
        getAllOrganizationTreeByUser({}).then((res) => {
          this.orgaTree = res || []
        })
      },
      searchQuery() {
        this.loadData(1)
      },
      searchReset() {
        this.queryParam = {
          creator: undefined,
          customerId: undefined,
          depotId: undefined,
          categoryId: undefined,
          organizationId: undefined,
          sortType: 'quantity_desc',
          beginTime: moment().subtract(3, 'months').format('YYYY-MM-DD'),
          endTime: moment().format('YYYY-MM-DD'),
          dateRange: [moment().subtract(3, 'months'), moment()],
        }
        this.loadData(1)
      },
      paginationChange(current, pageSize) {
        this.ipagination.current = current
        this.ipagination.pageSize = pageSize
        this.loadData()
      },
      paginationShowSizeChange(current, pageSize) {
        this.ipagination.current = current
        this.ipagination.pageSize = pageSize
        this.loadData()
      },
      exportExcel() {
        const list = []
        const head = '商品名称,商品规格,商品类型,销售数量,销售金额'
        // 过滤表格中的合计行
        const exportData = this.dataSource.filter(item => item.rowIndex !== '合计')
        for (let i = 0; i < exportData.length; i++) {
          const ds = exportData[i]
          list.push([
            ds.mName || '',
            ds.standard || '',
            ds.categoryName || '',
            ds.numSum || 0,
            ds.priceSum || 0
          ])
        }
        let tip = '查询条件：操作员=' + (this.queryParam.creator || '全部') +
          ', 客户=' + (this.queryParam.customerId || '全部') +
          ', 仓库=' + (this.queryParam.depotId || '全部') +
          ', 类别=' + (this.queryParam.categoryId || '全部') +
          ', 日期=' + this.queryParam.beginTime + '~' + this.queryParam.endTime +
          ', 排序=' + this.queryParam.sortType
        // 添加合计行
        let totalItem = ['-', '-', '-', 0, 0]
        for (let i = 0; i < exportData.length; i++) {
          const ds = exportData[i]
          totalItem[3] += Number.parseFloat(ds.numSum || 0)
          totalItem[4] += Number.parseFloat(ds.priceSum || 0)
        }
        totalItem[3] = totalItem[3].toFixed(2)
        totalItem[4] = totalItem[4].toFixed(2)
        list.push(totalItem)
        this.handleExportXlsPost('销售排行', '销售排行', head, tip, list)
      }
    }
  }
</script>
<style scoped>
</style>
